export default __webpack_public_path__ + "static/media/in500 front 1.388041be.png";